import Vue from 'vue'
import App from './App.vue'

// import 'babel-polyfill'
import 'core-js/es'
import 'core-js/stable'

import 'regenerator-runtime/runtime'

import '@/styles/tailwind.css'
import '@/styles/main.scss'
import '@/styles/custom.scss'
window.$ = window.jQuery = require('jquery')

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_CODE }
});

// Vue Router
import router from './router'
// Vuex Store
import store from './store'
import plugins from '@/plugins'

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import '@/antd.component'
import '@/main.components'

// @see https://floating-vue.starpad.dev/guide/
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
Vue.use(FloatingVue);

// vue2-smooth-scroll
import { Modal } from 'ant-design-vue'
import VueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(VueSmoothScroll, {
  updateHistory: false
})

Vue.prototype.$confirm = Modal.confirm

// https://www.npmjs.com/package/vue-clipboard2
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import '@/assets/css/toastr.css'
import Toasted from 'vue-toasted'
Vue.use(Toasted, {
  position: 'top-right',
  duration: 3000
})

const context = {
  router,
  store
}
for (const plugin of plugins) {
  const inject = (name, value) => {
    const prop = `$${name.replace(/^\$+/g, '')}`
    Vue.prototype[prop] = Vue.observable(value)
    context[prop] = Vue.prototype[prop]
  }
  Vue.use({
    install() {
      plugin(context, inject)
    }
  })
}

// usage: this.$loading.show(), this.$loading.hide()
import AntdSpinner from '@/plugins/ant-design-spinner'
Vue.use(AntdSpinner, { store })

import Notifications from 'vue-notification'
Vue.use(Notifications)

// Filters
import '@/filters'
export const bus = new Vue()

import global_func from '@/mixins/global_func.js'
Vue.mixin(global_func)

import CONST_DATA from '@/mixins/const/setMixins'
Vue.mixin(CONST_DATA)

Vue.prototype.$filters = Vue.options.filters

Vue.config.productionTip = false
Vue.config.performance = true
const app = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

// ブラウザバック（BFCache 復元等）で戻ってきたときの補完処理
// ブラウザバックorフォワードの判定
const isBackOrForwardNavigation = () => {
  console.log('isBackOrForwardNavigation called');
  try {
    const entries = typeof performance !== 'undefined' && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')
      : [];
    const navType = entries && entries[0] && entries[0].type;
    return navType === 'back_forward';
  } catch (e) {
    return false;
  }
};

const handlePageShow = (event) => {
  console.log('handlePageShow called');
  const fromBFCache = event && event.persisted === true;
  // BFキャッシュを復元したか、ブラウザバック・フォワードによる遷移の場合
  if (fromBFCache || isBackOrForwardNavigation()) {
    // 表示中ページのパスを取得
    const currentPath = window.location && window.location.pathname;
    if (currentPath === '/authorization/redirect') {
      window.location.href = process.env.VUE_APP_TOP_DOMAIN;
    }
  }
};

window.addEventListener('pageshow', handlePageShow);

// 即時チェック（イベント未発火やタイミング依存の取りこぼし対策）
//if (window.location && window.location.pathname === '/authorization/redirect') {
//  window.location.href = process.env.VUE_APP_TOP_DOMAIN;
//}
console.log('add pageshow called');

export default app
